<template>
  <v-card
    class="nx-form-more-info-wrapper" flat
    v-validate="validation"
    data-vv-value-path="value"
    :data-vv-scope="scope"
    :data-vv-name="name"
    :data-vv-as="label"
    value="1">
    <v-card-actions v-if="button">
      <v-btn
        outline
        :to="compRoute"
        target="_blank"
      >
        {{ compTitle }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import get from 'lodash/get';

export default {
  name: 'nx-form-more-info',
  mixins: [FormElement],
  props: {
    title: String,
    button: Object,
    value: {
      type: [Number, Object],
      default: 1,
    },
  },
  computed: {
    compTitle() {
      return get(this.value, 'title', null) || get(this.button, 'title') || this.title;
    },
    compRoute() {
      return get(this.value, 'route', null) || get(this.button, 'route');
    },
  },
};
</script>
